/* jshint -W024 */
import Roles from '@/domain/rolesEnum';
import store from '@/ui/store';
import i18n from '@/ui/i18n';

const ClientRoutes = [
  {
    path: '/credit-resume',
    name: 'credit-resume',
    meta: {
      auth: true,
      roles: [Roles.CLIENT],
      title: i18n.t('clientRouter.myCredits'), // Mis créditos
      iconName: 'fingerprint'
    },
    component: () => import('@/ui/components/internal/credit-resume/CreditResume.vue')
  },
  {
    path: '/pagar-aqui',
    name: 'pay-here',
    redirect: { name: 'choice' },
    meta: {
      auth: true,
      roles: [Roles.CLIENT],
      title: i18n.t('clientRouter.payHere'), // Pagar aquí
      iconName: 'credit-card'
    },
    component: () => import('@/ui/layout/internal/pay-here/PayHere.vue'),
    children: [
      {
        path: 'seleccionar',
        name: 'choice',
        alias: 'pay-neat',
        meta: {
          auth: true
        },
        component: () => import('@/ui/views/internal/pay-here/Select.vue')
      },
      {
        path: 'medio-de-pago',
        name: 'payment-provider',
        meta: {
          auth: true
        },
        beforeEnter(to, from, next) {
          if (!store.state.paymentsModule.total) {
            return next({ name: 'choice' });
          }
          return next();
        },
        component: () => import('@/ui/views/internal/pay-here/Pay.vue')
      },
      {
        path: 'pagar-manual',
        name: 'pay-manual',
        meta: {
          auth: true
        },
        beforeEnter(to, from, next) {
          if (store.state.paymentsModule.paymentMethod.slug !== 'WIRE_TRANSFER') {
            return next({ name: 'payment-provider' });
          }
          return next();
        },
        component: () => import('@/ui/views/internal/pay-here/PayWireTransfer.vue')
      },
      {
        path: 'pagar-presencial',
        name: 'pay-cash-deposit',
        meta: {
          auth: true
        },
        beforeEnter(to, from, next) {
          if (store.state.paymentsModule.paymentMethod.slug !== 'CASH_DEPOSIT') {
            return next({ name: 'payment-provider' });
          }
          return next();
        },
        component: () => import('@/ui/views/internal/pay-here/PayCashDeposit.vue')
      },
      {
        path: 'pagar-floid',
        name: 'pay-floid',
        meta: {
          auth: true
        },
        beforeEnter(to, from, next) {
          if (store.state.paymentsModule.paymentMethod.slug !== 'FLOID') {
            return next({ name: 'payment-provider' });
          }
          return next();
        },
        component: () => import('@/ui/views/internal/pay-here/PayFloid.vue')
      },
      {
        path: 'pagar-servipag',
        name: 'pay-servipag',
        meta: {
          auth: true
        },
        beforeEnter(to, from, next) {
          if (store.state.paymentsModule.paymentMethod.slug !== 'SERVIPAG_BUTTON') {
            return next({ name: 'payment-provider' });
          }
          return next();
        },
        component: () => import('@/ui/views/internal/pay-here/PayServipag.vue')
      },
      {
        path: 'verificar',
        name: 'check',
        meta: {
          auth: true
        },
        beforeEnter(to, from, next) {
          if (store.state.paymentsModule.paymentMethod === '') {
            return next({ name: 'choice' });
          }
          return next();
        },
        component: () => import('@/ui/views/internal/pay-here/Check.vue')
      }
    ]
  },
  {
    name: 'transactions-history',
    path: '/historial-pagos',
    meta: {
      auth: true,
      title: i18n.t('clientRouter.transactions-history'), // Historial de pago
      iconName: 'history',
      roles: [Roles.CLIENT]
    },
    component: () => import('@/ui/views/internal/pay-here/TransactionsHistoryContainer.vue')
  },
  {
    path: '/docs',
    name: 'docs',
    meta: {
      title: i18n.t('clientRouter.documents'), // Documentos
      iconName: 'poll-h'
    },
    component: () => import('@/ui/views/internal/docs/Docs.vue')
  },
  {
    path: '/support',
    parentName: 'header-menu',
    name: 'support',
    meta: {
      roles: [Roles.CLIENT],
      title: i18n.t('clientRouter.help'), // Ayuda
      iconName: 'headset'
    },
    component: () => import('@/ui/views/internal/support/SupportDashboard.vue')
  },
  {
    path: '/check-in',
    name: 'check-in',
    redirect: { name: 'welcome' },
    meta: {
      roles: [Roles.CLIENT],
      title: 'Check-in',
      iconName: 'rocket'
    },
    beforeEnter(to, from, next) {
      const { checkIn } = store.state.currentUser.user;
      if (!checkIn || checkIn.is || !checkIn.required) {
        next({ name: 'main' });
      } else next();
    },
    component: () => import('@/ui/layout/internal/check-in/CheckIn.vue'),
    children: [
      {
        path: 'bienvenida',
        name: 'welcome',
        meta: {
          auth: true
        },
        component: () => import('@/ui/views/internal/check-in/Welcome.vue')
      },
      {
        path: 'terminos',
        name: 'terms',
        meta: {
          auth: true
        },
        component: () => import('@/ui/views/internal/check-in/Terms.vue')
      },
      {
        path: 'firma',
        name: 'sign',
        meta: {
          auth: true
        },
        component: () => import('@/ui/views/internal/check-in/Sign.vue')
      },
      {
        path: 'confirma',
        name: 'confirmed',
        meta: {
          auth: true
        },
        component: () => import('@/ui/views/internal/check-in/Confirmed.vue')
      }
    ]
  }
];

export default ClientRoutes;
